const prefix = '[AwardCommitteeMeetings]';

export class LoadMeetings {
    static readonly type = `${prefix} Load`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreMeetings {
    static readonly type = `${prefix} Load More`;
}
